/* istanbul ignore file */
/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

const CONSTANTS = {
    CONTENT_TYPES: {
        KEY_ART: {
            id: 1,
            name: 'Key Art',
            subType: {
                ART_PROMO: {id: 1, name: 'Art - Promo', imageSuperType: 1},
                BOX_ART: {id: 2, name: 'Box Art', imageSuperType: 1},
                KEY_ART: {id: 3, name: 'Key Art', imageSuperType: 1},
                KEY_ART_INTERNAITONAL_VERSION: {id: 4, name: 'Key Art - International Version', imageSuperType: 1},
                KEY_ART_TELEVISION_SERIES: {id: 5, name: 'Key Art - Television Series', imageSuperType: 1},
                KET_ART_TEXTED: {id: 6, name: 'Key Art - Texted', imageSuperType: 1},
                KEY_ART_TEXTLESS: {id: 7, name: 'Key Art - Textless', imageSuperType: 1},
                KEY_ART_TITLED: {id: 8, name: 'Key Art - Titled', imageSuperType: 1},
                KEY_ART_WITH_TITLE: {id: 9, name: 'Key Art - With Title Treatment', imageSuperType: 1},
                VIDEO_BOX_ART: {id: 10, name: 'Video Box Art', imageSuperType: 1},
            }
        },
        OUTDOOR_ART: {
            id: 2,
            name: 'Outdoor Art',
            subType: {
                KISOK_ART: {id: 11, name: 'Kiosk Art', imageSuperType: 2},
                BILLBOARD: {id: 12, name: 'Billboard', imageSuperType: 2},
            }
        },
        ONLINE: {
            id: 3,
            name: 'Online',
            subType: {
                BANNER: {id: 13, name: 'Banner', imageSuperType: 3},
                WEB_SITE_OTHER: {id: 15, name: 'Web Site - Other', imageSuperType: 3},
                WEB_SITE_WBITV: {id: 16, name: 'Web Site - WBITV', imageSuperType: 3},
                WEB_SITE_WBITV_B2B: {id: 17, name: 'Web Site - WBITV B2B', imageSuperType: 3}
            }
        },
        LOGO: {
            id: 4,
            name: 'Logo',
            subType: {
                LOGO_ANIMATION: {id: 18, name: 'Logo - Animation', imageSuperType: 4},
                LOGO_MOVIDE_OF_WEEK: {id: 19, name: 'Logo - Movie Of The Week', imageSuperType: 4},
                LOGO_NETWORK_STATION: {id: 20, name: 'Logo - Network/Station', imageSuperType: 4},
                LOGO_PRODUCTION_COMPANY: {id: 21, name: 'Logo - Production Company', imageSuperType: 4},
                LOGO_SERIES: {id: 22, name: 'Logo - Series', imageSuperType: 4},
                LOGO_THEATRICAL: {id: 23, name: 'Logo - Theatrical', imageSuperType: 4},
                LOGO_WB_DIVISION: {id: 24, name: 'Logo - WB Division', imageSuperType: 4},
                TITLE_TREATMENT_ON_AIR: {id: 25, name: 'Title Treatment - On-air', imageSuperType: 4},
                TITLE_TREATMENT_PRINT: {id: 26, name: 'Title Treatment - Print', imageSuperType: 4}
            }
        },
        PHOTOGRAPHY_STILLS: {
            id: 5,
            name: 'Photography/Stills',
            subType: {
                PHOTOGRAPHY: {id: 27, name: 'Photography', imageSuperType: 5},
                UNIT: {id: 28, name: 'Unit', imageSuperType: 5},
                EPISODIC: {id: 29, name: 'Episodic', imageSuperType: 5},
                ANIMATED_STILLS: {id: 30, name: 'Animated Stills', imageSuperType: 5}
            }
        },
        GALLERY: {
            id: 6,
            name: 'Gallery',
            subType: {
                GALLERY: {id: 31, name: 'Gallery', imageSuperType: 6},
                GALLERY_CAST: {id: 32, name: 'Gallery - Cast', imageSuperType: 6},
                GALLERY_MUTIPLE: {id: 33, name: 'Gallery - Multiple', imageSuperType: 6},
                GALLERY_SINGLE: {id: 34, name: 'Gallery - Single', imageSuperType: 6},
                HEADSHOTS: {id: 35, name: 'Headshots', imageSuperType: 6},
                SET: {id: 36, name: 'Set', imageSuperType: 6},
            }
        },
        SVOD: {
            id: 7,
            name: 'SVOD',
            subType: {
                SVOD_VERTICAL_DISPLAY_ART: {id: 37, name: 'SVOD vertical display art', imageSuperType: 7},
                SVOD_HORIZONTAL_DISPLAY_ART: {id: 38, name: 'SVOD horizontal display art', imageSuperType: 7},
                STORY_ART: {id: 39, name: 'Story Art', imageSuperType: 7}
            }
        },
        CLIENT_SAMPLES: {
            id: 8,
            name: 'Client Samples/ Created',
            subType: {
                CLIENT_CREATED: {id: 40, name: 'Client-created', imageSuperType: 8}
            }
        },
        ANIMATION_PRODUCTON_MATERIALS: {
            id: 9,
            name: 'Animation Production Material',
            subType: {
                ANIMATION_COMPOSITE: {id: 41, name: 'Animation Composite', imageSuperType: 9},
                BACKGROUNDS: {id: 42, name: 'Backgrounds', imageSuperType: 9},
                CHARACTER_STOCK: {id: 43, name: 'Character - Stock', imageSuperType: 9},
                CHARACTER_ART: {id: 44, name: 'Character Art', imageSuperType: 9},
                CHARACTER_ART_ANIMATION: {id: 45, name: 'Character Art - Animation', imageSuperType: 9},
                CHARACTER_ART_GENERAL: {id: 46, name: 'Character Art- General', imageSuperType: 9}
            }
        },
        BTS: {
            id: 10,
            name: 'BTS',
            subType: {
                BEHIND_THE_SCENES: {id: 47, name: 'Behind the Scenes', imageSuperType: 10}
            }
        },
        OTHER: {
            id: 11,
            name: 'Other',
            subType: {
                OTHER: {id: 52, name: 'Other', imageSuperType: 11},
                AD_CONTEST: {id: 53, name: 'Ad - Contest/Promo', imageSuperType: 11},
                AD_COVER: {id: 54, name: 'Ad - Cover', imageSuperType: 11},
                AD_TRADE: {id: 55, name: 'Ad - Trade', imageSuperType: 11},
                ADVERTISING: {id: 56, name: 'Advertising', imageSuperType: 11},
                ART_MERCHANDISE: {id: 57, name: 'Art - Merchandise', imageSuperType: 11},
                MERCHANDISE_ART: {id: 58, name: 'Merchandise Art', imageSuperType: 11},
                MERCHANDISE: {id: 59, name: 'Merchandise', imageSuperType: 11},
                BAGS: {id: 60, name: 'Bags', imageSuperType: 11},
                CONTENT_ASSET_LIBRARY: {id: 61, name: 'Content Asset Library', imageSuperType: 11},
                CUSTOM_DVD_PACKAGING: {id: 62, name: 'Custom DVD/CD/VHS Packaging Clamshells', imageSuperType: 11},
                ILLUSTRATOR_TEMPLATE: {id: 63, name: 'Illustrator - Template', imageSuperType: 11},
                INSERT_DVD: {id: 64, name: 'Insert - DVD', imageSuperType: 11},
                MARKETING_SALES_KIT: {id: 65, name: 'Marketing Sales Kit', imageSuperType: 11},
                PHOTOSHOP_ACTION: {id: 66, name: 'Photoshop - Action', imageSuperType: 11},
                PRODUCT: {id: 67, name: 'Product', imageSuperType: 11},
                PRMOTIONAL_PACKAGING: {id: 68, name: 'Promotional Packaging', imageSuperType: 11},
                STOCK: {id: 69, name: 'Stock', imageSuperType: 11},
                STOCK_WB_COPYRIGHT: {id: 70, name: 'Stock - WB Copyright', imageSuperType: 11},
                TEASER_CAMPAIGN: {id: 71, name: 'Teaser Campaign', imageSuperType: 11}
            }
        },
        SOCIAL_MEDIA: {
            id: 12,
            name: 'Social Media',
            subType: {
                GIF: {id: 72, name: 'GIF', imageSuperType: 12},
                COUNTDOWN_CARD: {id: 73, name: 'Countdown Card', imageSuperType: 12},
                SOCIAL_MEDIA_CLIP: {id: 74, name: 'Social Media Clip', imageSuperType: 12},
                CHARACTER_CARD: {id: 75, name: 'Character Card', imageSuperType: 12}
            }
        },
        EVENTS: {
            id: 13,
            name: 'Events',
            subType: {
                EVENTS: {id: 48, name: 'Events', imageSuperType: 13},
                EVENTS_IJP: {id: 49, name: 'Events - IPJ', imageSuperType: 13},
                EVENTS_LA_SCREENINGS: {id: 50, name: 'Events - LA Screenings', imageSuperType: 13},
                EVENTS_MISC: {id: 51, name: 'Events - Misc.', imageSuperType: 13}
            }
        },
        HBO_MAX: {
            id: 14,
            name: 'HBO Max',
            subType: {
                TILE: {id: 76, name: 'Tile', imageSuperType: 14},
                TILE_BURNED_IN: {id: 77, name: 'Tile - Burned In', imageSuperType: 14},
                BACKGROUND: {id: 78, name: 'Background', imageSuperType: 14},
                LOGO_HBO_MAX: {id: 79, name: 'Logo - HBO Max', imageSuperType: 14},
                UNIVERSAL_SEARCH: {id: 80, name: 'Universal Search', imageSuperType: 14},
                EPISODIC_TILE: {id: 81, name: 'Episodic Tile', imageSuperType: 14}
            }
        }
    },

    toArray: function(constant) {
        return Object.keys(this[constant])
            .map(k => this[constant][k])
            .sort((a, b) => a.name.localeCompare(b.name));
    }
};

CONSTANTS.CONTENT_TYPE_MAP = Object.keys(CONSTANTS.CONTENT_TYPES).reduce( (o, k) => {
    o = Object.keys(CONSTANTS.CONTENT_TYPES[k].subType).reduce( (o1, k1) => {
        let item = CONSTANTS.CONTENT_TYPES[k].subType[k1];
        o1[item.id] = item;
        return o1;
    }, o);
    return o;
}, {});

export {
    CONSTANTS as IMAGE_CT_TYPES
};
